// extracted by mini-css-extract-plugin
module.exports = {"CopyToClipboardText":"CopyToClipboardText_xvlbi","CopyToClipboardTextNowrap":"CopyToClipboardTextNowrap_c9yUS","CopyToClipboardIcon":"CopyToClipboardIcon_hjx9o"};